import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useLang } from "../../context/LangContext";
import { ProductCard } from "./ProductCard";
import { Reveal } from "./Reveal";

export const SectionHead = ({ eyebrow, title, to, testid }) => {
  const { t, isRTL } = useLang();
  const Arrow = isRTL ? ArrowLeft : ArrowRight;
  return (
    <div className="mb-10 flex items-end justify-between gap-6 sm:mb-14">
      <div>
        {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
        <h2 className="text-3xl leading-tight sm:text-4xl lg:text-5xl">{title}</h2>
      </div>
      {to && (
        <Link to={to} data-testid={testid} className="group flex shrink-0 items-center gap-2 text-[13px] tracking-[0.1em]">
          <span className="link-u">{t("view_all")}</span>
          <Arrow size={16} strokeWidth={1.3} className="transition-transform duration-300 group-hover:-translate-x-1 rtl:group-hover:translate-x-[-4px]" />
        </Link>
      )}
    </div>
  );
};

export const ProductRail = ({ eyebrow, title, to, products, testid }) => {
  if (!products?.length) return null;
  return (
    <section data-testid={testid} className="container-q py-20 sm:py-28">
      <SectionHead eyebrow={eyebrow} title={title} to={to} testid={`${testid}-view-all`} />
      <div className="no-scrollbar -mx-5 flex snap-x gap-5 overflow-x-auto px-5 sm:mx-0 sm:grid sm:grid-cols-2 sm:gap-8 sm:overflow-visible sm:px-0 lg:grid-cols-4">
        {products.slice(0, 4).map((p, i) => (
          <Reveal key={p.id} delay={i * 0.08} className={`w-[72vw] shrink-0 snap-start sm:w-auto ${i % 2 === 1 ? "lg:mt-16" : ""}`}>
            <ProductCard p={p} />
          </Reveal>
        ))}
      </div>
    </section>
  );
};
